import apiClient from '../client/api-client'
import axios from 'axios'
import { baseURL } from 'config'
const dicomProxyUrl = '/dicom/pacs'
const details = 'details'
const studyRequestMapping = 'study-request-mapping'

export default {
  async fetchDicomStudies(payload) {
    if (payload.token) {
      try {
        const { data } = await axios.get(`${baseURL}/${dicomProxyUrl}/${details}`, {
          headers: {
            Authorization: `Bearer ${payload.token}`,
            'Content-Type': 'application/json'
          },
          params: {
            grantor: payload.grantor,
            grantee: payload.grantee
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    } else {
      try {
        const { data } = await apiClient.get(`${dicomProxyUrl}/${details}`, {
          params: {
            grantor: payload.grantor,
            grantee: payload.grantee
          }
        })
        return data
      } catch (err) {
        throw new Error(err)
      }
    }
  },
  async fetchDicomStudiesByRequestId(payload) {
    try {
      const { data } = await apiClient.get(
        `${dicomProxyUrl}/${studyRequestMapping}/${payload.id}`,
        {
          params: {
            id: payload.id,
            grantor: payload.grantor,
            grantee: payload.grantee
          }
        }
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  }
}
